import React, { createContext, useEffect, useState } from "react";
import Cookies from "js-cookie";

const AUTH_LOCAL_STORAGE = "auth";
const AUTH_COOKIE = "auth_token";

const initialState = { token: null };
const AuthContext = createContext({
  auth: initialState,
  setAuth: ({}) => {},
});

export function AuthProvider({ children }) {
  const [auth, setAuth] = useState(() => {
    let lsAuth = {};
    try {
      lsAuth =
        JSON.parse(localStorage.getItem(AUTH_LOCAL_STORAGE) || "{}") || {};
    } catch {
      lsAuth = {};
    }

    const tokenFromCookie = Cookies.get(AUTH_COOKIE) || null;
    const tokenFromLS = lsAuth?.token ?? null;
    const token = tokenFromCookie || tokenFromLS || null;
    if (!tokenFromCookie && tokenFromLS) {
      delete lsAuth.token;
      localStorage.setItem(AUTH_LOCAL_STORAGE, JSON.stringify(lsAuth));
    }
    if (!token) {
      // on page load, revalidate auth state if no token is found
      return { ...lsAuth, token: true };
    }

    return { ...lsAuth, token };
  });

  useEffect(() => {
    const { token, ...rest } = auth || {};
    localStorage.setItem(AUTH_LOCAL_STORAGE, JSON.stringify(rest));

    const body = document.documentElement;
    const cursor = rest?.cursor?.defaultStateUrl;
    const hover = rest?.cursor?.hoverStateUrl;

    body.style.setProperty(
      "--def-cursor",
      cursor ? `url("${cursor}"), default` : "default"
    );
    body.style.setProperty(
      "--def-hover-cursor",
      hover ? `url("${hover}"), pointer` : "pointer"
    );
  }, [auth]);

  return (
    <AuthContext.Provider value={{ auth, setAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export default AuthContext;
